<template>
    <GenericTable
        :Variant="Variant" 
        :Headers="headers"
        :Rows="Results"
        :EnableSelection="true"
        :SelectionType="selectionTypeEnum.Simple"
        :EnablePagination="true"
        :PerPage="itemPerPage"
        :ShowDeleteButton="false"
        :ShowModifyButton="false"
        :ShowSearchField="false"
        :ShowColumnsSelector="false"
        :ShowToggleSelectionAll="false"
        @ClickOnRowsEvent="OnRowSelected"/>
</template>
<script lang="ts">
    /**
     * Composants VUE
     */
    import Component from 'vue-class-component';

    import { SearchDisplayer } from '../SearchDisplayer';

    /**
     * Composant table générique
     */
    import { HeaderIcon, HeaderString, IconType, IHeader } from '../../Generics/GenericTable/GenericTableHeader';
    import GenericTable, { CssClass } from '../../Generics/GenericTable.vue';

    @Component({
        components: {
            GenericTable
        }
    })
    export default class ShortLBOSearchDisplayer extends SearchDisplayer {

        /**
         * En-têtes de colonnes du tableau d'affichage des résultats de recherche de LBO.
         */
        private headers:  IHeader[] = [
            new HeaderIcon('ObjectType', this.$t('ObjectType').toString(), {Sort: false, ShowLabel: false, CssClasses : [new CssClass({CssClass: 'text-center'})], IconType: IconType.Path}),
            new HeaderString('Invariant', this.$t('Invariant').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderString('Name', this.$t('Name').toString(), {Sort: true, CssClasses : [new CssClass({CssClass: 'text-center'})]}),
            new HeaderString('Properties', this.$t('Properties').toString(), {Sort: false, CssClasses : [new CssClass({CssClass: 'text-center'})]})
        ]
    }
</script>
<style scoped>
</style>